<template>
    <div>
      <div class="modal hide fade" id="modalPurchasingImportTax" tabindex="-1" role="dialog" aria-labelledby="modalPurchasingImportTax" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Request Edit</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <input type="file" id="file" ref="file" />
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="requestEdit">Process</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'PurchasingImportModal',
  data () {
    return {
      max: 100,
      request_edit: '',
      request_void: '',
      file: null
    }
  },
  methods: {
    requestEdit () {
      this.file = this.$refs.file.files[0]
      console.log(this.file)
      this.$emit('getUploadFile', this.file)
    }
  }
}
</script>
